import { Slide, Stage } from '@app/widgets/canvas/types';

export const isSuccessfulCompose = (stage: Stage) =>
  stage.type === 'compose' && stage.status === 'success';

export const isFailedStage = (stage: Stage): boolean => stage.status === 'fail';

export const isComposeFail = (stages: Stage[]): boolean => {
  return stages.some((stage) => stage.type === 'compose' && stage.status === 'fail');
};

export const isRestylingFail = (stages: Stage[]): boolean => {
  return stages.some((stage) => stage.type === 'restyling' && stage.status === 'fail');
};

export const isEditSlide = (stages: Stage[]): boolean => {
  return stages.some((stage) => stage.type === 'editableSlide' && stage.status === 'success');
};

export const isCloningSlide = (stages: Stage[]): boolean => {
  return stages.some((stage) => stage.type === 'cloning' && stage.status === 'running');
};

export const isEmptyStage = (stages: Stage[]): boolean => {
  return stages.length === 0;
};

export const isComposeSuccess = (stages: Stage[]): boolean => {
  return stages.some((stage) => stage.type === 'compose' && stage.status === 'success');
};

export const isMarkupSuccess = (stages: Stage[]): boolean => {
  return stages.some((stage) => stage.type === 'markup' && stage.status === 'success');
};

export const isUserCreatedSlide = (stages: Stage[]): boolean => {
  return stages.some((stage) => stage.type === 'userCreated');
};

export const isRelayout = (slide: Slide): boolean => {
  return slide.is_relayout_running ?? false;
};

export const isRepaint = (slide: Slide): boolean => {
  return slide.is_repaint_running ?? false;
};

// функции для restyling
export const isRestylingSuccess = (stages: Stage[]): boolean => {
  return stages.some((stage) => stage.type === 'restyling' && stage.status === 'success');
};

export const isRestylingRunning = (stages: Stage[]): boolean => {
  return stages.some((stage) => stage.type === 'restyling' && stage.status !== 'success');
};

export const isRestyling = (slide: Slide): boolean => {
  return slide.stages.some((stage) => stage.type === 'restyling' && stage.status !== 'success');
};

export const isRestylingError = (stages: Stage[]): boolean => {
  return stages.some((stage) => stage.type === 'restyling' && stage.status === 'fail');
};
